export default __webpack_public_path__ + "static/logo-2-484abcec075731534f50b579110417d6.svg";